module.exports = __webpack_public_path__ + "static/media/pic2@2x.a692955c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_146/img/pic2@2x.png
// module id = 1395
// module chunks = 0